export enum LanguageTypes {
  English = 1,
  Spanish = 2,
  French = 3,
}
